/* Combined delivery-estimate widget: India pincode checker (Shiprocket-backed
   dispatch/ETA via the reviews App Proxy) + international shipping estimator
   (real Shopify Ajax /cart/shipping_rates.json + Shopify.CountryProvinceSelector,
   same engine as the cart-page calculator). See snippets/delivery-estimate.liquid.

   The international delivery-window message is computed client-side (11:00 IST
   cutoff + ready_to_ship/processing_days metafields, mirroring
   api/services/shipping/dispatch_service.py) so it doesn't need a backend
   round-trip - transit is a fixed 10-15 days for international.

   Full-width status row, one crisp line, colored + iconed per delivery
   speed (Quick/Express/Standard). Quick Delivery additionally reveals an
   animated claim badge - a CSS-only one-time pop, no extra JS timers. */
(function () {
  var STRINGS = window.deliveryEstimateStrings || {};
  var COOKIE_NAME = 't4s_delivery_pincode';
  var COOKIE_DAYS = 30;
  var IST_OFFSET_MS = 5.5 * 60 * 60 * 1000;
  var INTL_MAX_TRANSIT_DAYS = 15;
  var CUTOFF_HOUR_IST = 12;

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function ordinal(n) {
    var s = ['th', 'st', 'nd', 'rd'];
    var v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }

  function formatDate(isoDate) {
    var d = new Date(isoDate + 'T00:00:00');
    var weekday = d.toLocaleDateString('en-US', { weekday: 'short' });
    var month = d.toLocaleDateString('en-US', { month: 'short' });
    return weekday + ', ' + ordinal(d.getDate()) + ' ' + month;
  }

  function nowIST() {
    var now = new Date();
    var utcMs = now.getTime() + now.getTimezoneOffset() * 60000;
    return new Date(utcMs + IST_OFFSET_MS);
  }

  function addDays(date, n) {
    var d = new Date(date);
    d.setDate(d.getDate() + n);
    return d;
  }

  function toIsoDate(date) {
    var y = date.getFullYear();
    var m = String(date.getMonth() + 1).padStart(2, '0');
    var d = String(date.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + d;
  }

  /* Pincode-independent "ships by" label for the collapsed default state -
     dispatch date only (when it leaves), not a delivery promise (when it
     arrives, which needs a pincode to estimate transit). */
  function shipsByLabel(dispatchDate) {
    var ist = nowIST();
    var today = new Date(ist.getFullYear(), ist.getMonth(), ist.getDate());
    var diffDays = Math.round((dispatchDate - today) / 86400000);
    if (diffDays <= 0) return STRINGS.shipsToday || 'Ships today';
    if (diffDays === 1) return STRINGS.shipsTomorrow || 'Ships by tomorrow';
    return (STRINGS.shipsBy || 'Ships by %%DATE%%').replace('%%DATE%%', formatDate(toIsoDate(dispatchDate)));
  }

  /* Minutes left until the same-day dispatch cutoff (noon IST) - 0 once it's
     passed. Used to show a live "order within Xh Ym" countdown instead of a
     flat date when there's still time to make today's dispatch. */
  function minutesUntilCutoff() {
    var ist = nowIST();
    var cutoff = new Date(ist.getFullYear(), ist.getMonth(), ist.getDate(), CUTOFF_HOUR_IST, 0, 0);
    return Math.max(0, Math.round((cutoff - ist) / 60000));
  }

  function formatCountdown(totalMinutes) {
    var h = Math.floor(totalMinutes / 60);
    var m = totalMinutes % 60;
    if (h > 0 && m > 0) return h + 'h ' + m + 'm';
    if (h > 0) return h + 'h';
    return m + 'm';
  }

  /* Mirrors dispatch_service.compute_dispatch_date() - same-day dispatch
     needs an order in before the noon IST cutoff. */
  function computeDispatchDate(readyToShip, processingDays) {
    var ist = nowIST();
    var base = new Date(ist.getFullYear(), ist.getMonth(), ist.getDate());
    if (ist.getHours() >= CUTOFF_HOUR_IST) base.setDate(base.getDate() + 1);
    if (!readyToShip) base.setDate(base.getDate() + Math.max(0, processingDays || 0));
    return base;
  }

  function formatMoney(amount) {
    var num = parseFloat(amount);
    if (isNaN(num)) return amount;
    if (window.T4SThemeSP && T4SThemeSP.Currency && typeof T4SThemeSP.Currency.formatMoney === 'function') {
      try { return T4SThemeSP.Currency.formatMoney(Math.round(num * 100)); } catch (e) {}
    }
    var symbol = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    return num.toFixed(2) + (symbol ? ' ' + symbol : '');
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  class DeliveryEstimate extends HTMLElement {
    connectedCallback() {
      this.endpoint = this.dataset.checkEndpoint;
      this.productId = this.dataset.productId;
      this.readyToShip = this.dataset.readyToShip === 'true' || this.dataset.readyToShip === '1';
      this.processingDays = parseInt(this.dataset.processingDays, 10) || 0;
      this.quickClaim = this.dataset.quickClaim || STRINGS.quickClaimDefault || 'Get it in 2 hours';
      this.country = 'IN';

      this.summaryEl = this.querySelector('[data-delivery-summary]');
      this.summaryIcon = this.querySelector('[data-summary-icon]');
      this.summaryText = this.querySelector('[data-summary-text]');
      this.summaryAction = this.querySelector('[data-summary-action]');
      this.expandPanel = this.querySelector('[data-delivery-expand]');

      this.countryInputs = this.querySelectorAll('[data-delivery-country]');
      this.panelIn = this.querySelector('[data-delivery-panel-in]');
      this.panelIntl = this.querySelector('[data-delivery-panel-intl]');

      this.pincodeInput = this.querySelector('[data-pincode-input]');
      this.pincodeButton = this.querySelector('[data-pincode-check]');
      this.pincodeResult = this.querySelector('[data-pincode-result]');

      this.statusRow = this.querySelector('[data-delivery-status]');
      this.statusIcon = this.querySelector('[data-delivery-status-icon]');
      this.statusText = this.querySelector('[data-delivery-status-text]');
      this.quickBadge = this.querySelector('[data-quick-badge]');
      this.quickBadgeText = this.querySelector('[data-quick-badge-text]');

      this.intlStatus = this.querySelector('[data-intl-status]');
      this.intlStatusIcon = this.querySelector('[data-intl-status-icon]');
      this.intlStatusText = this.querySelector('[data-intl-status-text]');

      this.bikeTemplate = this.parentElement.querySelector('[data-delivery-estimate-icon-bike]') || document.querySelector('[data-delivery-estimate-icon-bike]');
      this.quickTemplate = this.parentElement.querySelector('[data-delivery-estimate-icon-quick]') || document.querySelector('[data-delivery-estimate-icon-quick]');
      this.boxTemplate = this.parentElement.querySelector('[data-delivery-estimate-icon-box]') || document.querySelector('[data-delivery-estimate-icon-box]');
      this.clockTemplate = this.parentElement.querySelector('[data-delivery-estimate-icon-clock]') || document.querySelector('[data-delivery-estimate-icon-clock]');

      this.intlCountrySelect = this.querySelector('[data-intl-country]');
      this.intlProvinceSelect = this.querySelector('[data-intl-province]');
      this.intlProvinceWrap = this.querySelector('[data-intl-province-wrap]');
      this.intlZipInput = this.querySelector('[data-intl-zip]');
      this.intlButton = this.querySelector('[data-intl-estimate]');
      this.intlResult = this.querySelector('[data-intl-result]');
      this.intlRatesTable = this.querySelector('[data-intl-rates-table]');
      this.intlRatesBody = this.querySelector('[data-intl-rates-body]');

      this.countryInputs.forEach(function (radio) {
        radio.addEventListener('change', this.onCountryChange.bind(this));
      }.bind(this));
      this.updateCountryPillActive();

      // Full instance only - the compact cart-line variant has no summary
      // row/expand panel, it just renders the status row directly.
      if (this.summaryEl && this.expandPanel) {
        this.summaryEl.addEventListener('click', function () {
          this.toggleExpand();
        }.bind(this));
        // Only paint the pincode-less default here if there's no saved
        // pincode to resolve below - avoids a flash of "Ships by..." right
        // before it flips to the confirmed "Delivered by..." a beat later.
        if (!getCookie(COOKIE_NAME)) this.renderSummaryDefault();
      }

      // Compact instances (see snippets/delivery-estimate.liquid `compact: true`)
      // render only the status row - no pincode input/button, no intl panel -
      // so all of this is optional here.
      if (this.pincodeButton && this.pincodeInput) {
        this.pincodeButton.addEventListener('click', this.onPincodeCheck.bind(this));
        this.pincodeInput.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') this.onPincodeCheck();
        }.bind(this));
        this.pincodeInput.addEventListener('input', function () {
          this.pincodeInput.value = this.pincodeInput.value.replace(/\D/g, '').slice(0, 6);
        }.bind(this));
      }

      if (this.intlButton) {
        this.initIntlSelector();
        this.intlButton.addEventListener('click', this.onIntlEstimate.bind(this));
        this.renderIntlDeliveryMessage();
      }

      var self = this;
      document.addEventListener('t4s:pincode-updated', function (event) {
        if (!event.detail || !event.detail.pincode) return;
        self.loadDispatch(event.detail.pincode);
      });

      var pincode = getCookie(COOKIE_NAME);
      if (pincode) {
        if (this.pincodeInput) this.pincodeInput.value = pincode;
        this.loadDispatch(pincode);
      }
    }

    initIntlSelector() {
      if (!window.Shopify || !Shopify.CountryProvinceSelector) return;
      new Shopify.CountryProvinceSelector(this.intlCountrySelect.id, this.intlProvinceSelect.id, {
        hideElement: this.intlProvinceWrap.id,
      });
    }

    renderSummaryDefault() {
      var dispatchDate = computeDispatchDate(this.readyToShip, this.processingDays);
      var ist = nowIST();
      var today = new Date(ist.getFullYear(), ist.getMonth(), ist.getDate());
      var dispatchingToday = this.readyToShip && dispatchDate.getTime() === today.getTime();

      this.setStatusIcon(this.summaryIcon, 'clock');
      this.summaryEl.classList.toggle('t4s-delivery-widget__summary--urgent', dispatchingToday);

      if (dispatchingToday) {
        var countdown = formatCountdown(minutesUntilCutoff());
        this.summaryText.textContent = (STRINGS.orderWithin || 'Order within %%TIME%% for dispatch today').replace('%%TIME%%', countdown);
      } else {
        this.summaryText.textContent = shipsByLabel(dispatchDate);
      }

      this.summaryAction.textContent = STRINGS.checkPincode || 'Check';
      this.summaryEl.classList.remove('t4s-delivery-widget__summary--confirmed');
      delete this.summaryEl.dataset.mode;
    }

    renderSummaryConfirmed(mode, deliveryWindowEndIso) {
      this.setStatusIcon(this.summaryIcon, mode);
      var dateText = mode === 'quick' ? (STRINGS.getItToday || 'Get it today') : (STRINGS.getItBy || 'Get it by %%DATE%%').replace('%%DATE%%', formatDate(deliveryWindowEndIso));
      this.summaryText.textContent = this.modeLabel(mode) + ' · ' + dateText;
      this.summaryAction.textContent = STRINGS.changePincode || 'Change';
      this.summaryEl.classList.add('t4s-delivery-widget__summary--confirmed');
      this.summaryEl.dataset.mode = mode;
    }

    toggleExpand(forceOpen) {
      if (!this.expandPanel) return;
      var willOpen = typeof forceOpen === 'boolean' ? forceOpen : this.expandPanel.hidden;
      if (willOpen) {
        this.expandPanel.hidden = false;
        // rAF so the browser paints the hidden->block change first, then the
        // class toggle on the next frame actually transitions instead of
        // snapping (hidden removal and a transitioned property can't both
        // land in the same paint).
        requestAnimationFrame(function () {
          this.expandPanel.classList.add('is--open');
        }.bind(this));
      } else {
        this.expandPanel.classList.remove('is--open');
        var self = this;
        window.setTimeout(function () {
          if (!self.expandPanel.classList.contains('is--open')) self.expandPanel.hidden = true;
        }, 380);
      }
      if (this.summaryEl) this.summaryEl.setAttribute('aria-expanded', String(willOpen));
    }

    updateCountryPillActive() {
      this.countryInputs.forEach(function (radio) {
        var label = radio.closest('.t4s-delivery-widget__country-option');
        if (label) label.classList.toggle('is--active', radio.checked);
      });
    }

    onCountryChange(event) {
      this.country = event.target.value;
      this.updateCountryPillActive();
      if (this.country === 'INTL') {
        this.panelIn.hidden = true;
        this.panelIntl.hidden = false;
      } else {
        this.panelIn.hidden = false;
        this.panelIntl.hidden = true;
        // Back to domestic - cart page reverts Shipping charges to Free.
        document.dispatchEvent(new CustomEvent('t4s:intl-rate-checked', { detail: { rates: [] } }));
      }
    }

    onPincodeCheck() {
      var pincode = (this.pincodeInput.value || '').trim();
      if (!/^\d{6}$/.test(pincode)) {
        this.hideStatusRow();
        this.renderPincodeResult('error', STRINGS.invalid || 'Please enter a valid 6-digit pincode.');
        return;
      }

      this.hideStatusRow();
      this.renderPincodeResult('loading', STRINGS.checking || 'Checking...');
      this.pincodeButton.disabled = true;

      var self = this;
      var url = this.endpoint + '?pincode=' + encodeURIComponent(pincode) + '&country=IN';
      if (this.productId) url += '&product_id=' + encodeURIComponent(this.productId);

      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          self.pincodeButton.disabled = false;
          if (!data.success) {
            self.hideStatusRow();
            self.renderPincodeResult('error', data.message || STRINGS.error || "Couldn't check delivery right now.");
            return;
          }
          if (!data.serviceable) {
            self.hideStatusRow();
            self.renderPincodeResult('error', data.message || STRINGS.notServiceable || 'Not deliverable to this pincode.');
            return;
          }
          setCookie(COOKIE_NAME, pincode, COOKIE_DAYS);
          document.dispatchEvent(new CustomEvent('t4s:pincode-updated', { detail: { pincode: pincode, productId: self.productId } }));
          if (data.dispatch_date) {
            self.pincodeResult.hidden = true;
            self.renderDispatchCard(data, { pincode: pincode, celebrate: true });
          } else {
            self.hideStatusRow();
            self.renderPincodeResult('success', data.message || STRINGS.serviceable || 'Delivery available to this pincode.');
          }
        })
        .catch(function () {
          self.pincodeButton.disabled = false;
          self.hideStatusRow();
          self.renderPincodeResult('error', STRINGS.error || "Couldn't check delivery right now.");
        });
    }

    hideStatusRow() {
      this.statusRow.hidden = true;
      this.quickBadge.hidden = true;
      this.quickBadge.classList.remove('t4s-delivery-widget__quick-badge--in');
    }

    renderPincodeResult(state, message) {
      this.pincodeResult.hidden = false;
      this.pincodeResult.textContent = message;
      this.pincodeResult.className = 't4s-delivery-widget__result t4s-delivery-widget__result--' + state;
    }

    loadDispatch(pincode) {
      var self = this;
      var url = this.endpoint + '?pincode=' + encodeURIComponent(pincode) + '&country=IN';
      if (this.productId) url += '&product_id=' + encodeURIComponent(this.productId);

      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data || !data.success || !data.serviceable || !data.dispatch_date) return;
          self.pincodeResult.hidden = true;
          self.renderDispatchCard(data);
        })
        .catch(function () {});
    }

    setStatusIcon(iconEl, mode) {
      var template = mode === 'quick' ? this.quickTemplate
        : mode === 'express' ? this.bikeTemplate
        : mode === 'clock' ? this.clockTemplate
        : this.boxTemplate;
      iconEl.innerHTML = template ? template.innerHTML : '';
    }

    modeLabel(mode) {
      return mode === 'quick' ? (STRINGS.modeQuick || 'Quick Delivery')
        : mode === 'express' ? (STRINGS.modeExpress || 'Express Dispatch')
        : (STRINGS.modeStandard || 'Standard Delivery');
    }

    renderDispatchCard(data, options) {
      options = options || {};
      this.statusRow.hidden = false;
      var mode = data.quick_delivery_available ? 'quick' : data.ready_to_ship ? 'express' : 'standard';

      this.statusRow.className = 't4s-delivery-widget__status t4s-delivery-widget__status--' + mode + ' t4s-delivery-widget__status--in';
      this.setStatusIcon(this.statusIcon, mode);

      var dateText = mode === 'quick' ? (STRINGS.getItToday || 'Get it today') : (STRINGS.getItBy || 'Get it by %%DATE%%').replace('%%DATE%%', formatDate(data.delivery_window_end));
      this.statusText.textContent = this.modeLabel(mode) + ' · ' + dateText;

      if (this.summaryEl) this.renderSummaryConfirmed(mode, data.delivery_window_end);

      if (mode === 'quick') {
        this.quickBadgeText.textContent = this.quickClaim;
        this.quickBadge.hidden = false;
        this.quickBadge.classList.add('t4s-delivery-widget__quick-badge--in');
        // Only celebrate on a fresh, interactive pincode check - not the
        // silent cookie/broadcast restore on page load (loadDispatch),
        // so returning visitors aren't greeted with the animation on
        // every single page view.
        if (options.celebrate && window.MinakiQuickDelivery) {
          window.MinakiQuickDelivery.play({
            pincode: options.pincode,
            headline: STRINGS.quickAnimHeadline || 'Quick Delivery Unlocked!',
            sub: this.quickClaim
          });
        }
      } else {
        this.quickBadge.hidden = true;
        this.quickBadge.classList.remove('t4s-delivery-widget__quick-badge--in');
      }

      // Fresh, interactive check (not the silent cookie/broadcast restore) -
      // let the shopper see the confirmation land inline, then settle the
      // widget back down to its one-line summary a beat later.
      if (options.celebrate && this.expandPanel) {
        var self = this;
        window.setTimeout(function () { self.toggleExpand(false); }, 1200);
      }
    }

    renderIntlDeliveryMessage() {
      var dispatchDate = computeDispatchDate(this.readyToShip, this.processingDays);
      var end = addDays(dispatchDate, INTL_MAX_TRANSIT_DAYS);
      var dateText = (STRINGS.getItBy || 'Get it by %%DATE%%').replace('%%DATE%%', formatDate(toIsoDate(end)));

      this.setStatusIcon(this.intlStatusIcon, 'standard');
      this.intlStatusText.textContent = this.modeLabel('standard') + ' · ' + dateText;
    }

    onIntlEstimate() {
      var country = this.intlCountrySelect.value || '';
      var province = this.intlProvinceSelect.value || '';
      var zip = (this.intlZipInput.value || '').trim();

      this.renderIntlResult('loading', STRINGS.intlChecking || 'Checking shipping rates...');
      this.intlRatesTable.hidden = true;
      this.intlButton.disabled = true;

      var params = new URLSearchParams({
        'shipping_address[country]': country,
        'shipping_address[province]': province,
        'shipping_address[zip]': zip,
      });

      var self = this;
      fetch('/cart/shipping_rates.json?' + params.toString(), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          self.intlButton.disabled = false;
          var rates = (data && data.shipping_rates) || [];
          if (!rates.length) {
            self.renderIntlResult('info', STRINGS.intlEmpty || 'Add this item to your cart to see exact international shipping rates.');
            return;
          }
          self.intlResult.hidden = true;
          self.intlRatesBody.innerHTML = rates.map(function (rate) {
            return '<tr><td>' + escapeHtml(rate.name) + '</td><td>' + formatMoney(rate.price) + '</td></tr>';
          }).join('');
          self.intlRatesTable.hidden = false;
          // Decoupled - harmless on the PDP, picked up by the cart page's
          // price-details panel to swap Shipping charges off the India
          // default-Free rule onto a real computed rate.
          document.dispatchEvent(new CustomEvent('t4s:intl-rate-checked', { detail: { rates: rates } }));
        })
        .catch(function () {
          self.intlButton.disabled = false;
          self.renderIntlResult('error', STRINGS.intlError || "Couldn't fetch shipping rates right now.");
        });
    }

    renderIntlResult(state, message) {
      this.intlResult.hidden = false;
      this.intlResult.textContent = message;
      this.intlResult.className = 't4s-delivery-widget__result t4s-delivery-widget__result--' + state;
    }
  }

  if (!customElements.get('delivery-estimate')) {
    customElements.define('delivery-estimate', DeliveryEstimate);
  }
})();
